import { goalStatusLabel, stripHtml } from "../../utils/goals";

const FIELD_LABELS = {
  title: "Goal",
  description: "Key Results / Measure of Success",
  status: "Status",
  due_date: "Due date",
};

function formatFieldName(field) {
  return FIELD_LABELS[field] || field;
}

function formatFieldValue(field, value) {
  if (value === null || value === undefined || value === "") return "—";
  if (field === "status") return goalStatusLabel(value);
  if (field === "description") return stripHtml(value) || "—";
  return String(value);
}

/**
 * Renders goal-specific activity metadata (initial snapshot on create, field diffs on update).
 * Matches Goal detail “Activity Log” field presentation for My Activity / Team Activity parity.
 */
export default function GoalActivityLogDetails({ entry }) {
  if (!entry || entry.entityType !== "goal" || !entry.metadata) return null;

  const { metadata, action } = entry;
  const snapshot = metadata.snapshot;
  const changes = metadata.changes;
  const actingForOther = metadata.actingForOther && metadata.goalOwnerName;

  if (action === "goal_created" && snapshot && typeof snapshot === "object") {
    const fields = ["title", "description", "status", "due_date"];
    return (
      <div className="mt-2 space-y-1">
        {actingForOther && (
          <div className="text-xs text-amber-800/90 bg-amber-50 border border-amber-100 rounded-md px-2 py-1.5 mb-1">
            Recorded for <span className="font-semibold">{metadata.goalOwnerName}</span>
            ’s goal (manager or admin action).
          </div>
        )}
        {fields.map((field) => (
          <div
            key={field}
            className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1"
          >
            <span className="font-semibold">{formatFieldName(field)}:</span>{" "}
            <span className="text-gray-800">{formatFieldValue(field, snapshot[field])}</span>
          </div>
        ))}
      </div>
    );
  }

  if (Array.isArray(changes) && changes.length > 0) {
    return (
      <div className="mt-2 space-y-1">
        {actingForOther && (
          <div className="text-xs text-amber-800/90 bg-amber-50 border border-amber-100 rounded-md px-2 py-1.5 mb-1">
            Changes to <span className="font-semibold">{metadata.goalOwnerName}</span>
            ’s goal (manager or admin action).
          </div>
        )}
        {changes.map((change, idx) => (
          <div
            key={`${entry.id}-${change.field}-${idx}`}
            className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1"
          >
            <span className="font-semibold">{formatFieldName(change.field)}:</span>{" "}
            <span className="text-gray-500">
              {formatFieldValue(change.field, change.previousValue)}
            </span>{" "}
            <span className="text-gray-400">→</span>{" "}
            <span className="text-gray-800">
              {formatFieldValue(change.field, change.newValue)}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return null;
}
